export const mockResponseConfig = {
  fetchIfNoMockResponse: true,
  preferMockResponse: false
};
